






































import { Component, Prop, Vue } from "vue-property-decorator";
import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: { StandartModal, onsubmit: SubmitResetButtonGroop },
})
export default class MobileHost extends Vue {
  @Prop({ type: String, default: "" }) mobile!: string;
  @Prop({ type: String, default: "" }) hotspot!: string;
  mobile_host = "";
  hotspot_host = "";

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.mobile_host != this.mobile)
      this.$emit("updateConfig", { mobile_host: this.mobile_host });
    if (this.hotspot_host != this.hotspot)
      this.$emit("updateConfig", { hotspot_host: this.hotspot_host });
    this.$bvModal.hide("root-setting-mobile-host");
  }

  onReset(): void {
    this.mobile_host = "";
    this.hotspot_host = "";
  }

  show(): void {
    this.mobile_host = this.mobile;
    this.hotspot_host = this.hotspot;
  }
}
